import { render, staticRenderFns } from "./PazienteConsensiList.vue?vue&type=template&id=d5d34f4e&scoped=true"
import script from "./PazienteConsensiList.vue?vue&type=script&lang=js"
export * from "./PazienteConsensiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d34f4e",
  null
  
)

export default component.exports